import { render } from "./SideBarMenu.vue?vue&type=template&id=313ef2b1&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=313ef2b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313ef2b1"]])

export default __exports__